import type { LookupState, TeamColor } from '../types';

export const teamColorHex: Record<TeamColor, string> = {
  blue: '#1976d2',
  green: '#2e7d32',
  purple: '#7b1fa2',
  orange: '#ef6c00',
  red: '#c62828',
  teal: '#00897b',
  gold: '#b58900',
  gray: '#757575',
};

export function teamAccentColor(value: unknown): string {
  const color = typeof value === 'string' && value in teamColorHex ? (value as TeamColor) : 'gray';
  return teamColorHex[color];
}

export function lookupTeamAccentColor(lookups: LookupState, teamId: string | null | undefined): string {
  const team = lookups.teams.find((option) => option.value === teamId);
  return teamAccentColor(team?.team_color || 'gray');
}
